import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';

function RegisterPage() {
    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccessMessage('');

        if (!username || !email || !password || !confirmPassword) {
            setError('All fields are required.');
            return;
        }

        if (password !== confirmPassword) {
            setError('Passwords do not match.');
            return;
        }

        try {
            // Ensure your AuthService is running on http://localhost:5201
            const response = await axios.post('/api/auth/register', {
                username: username,
                email: email,
                password: password
            });

            if (response.status === 200 && response.data && response.data.token) {
                setSuccessMessage('Registration successful! You can now log in.');
                // Optionally, redirect to login page after a short delay or on button click
                setTimeout(() => {
                    navigate('/login');
                }, 2000); // Redirect after 2 seconds
            } else {
                // Handle cases where backend returns 200 but with an error message
                setError(response.data.message || 'Registration failed. Please try again.');
            }
        } catch (err) {
            if (err.response && err.response.data && err.response.data.message) {
                setError(`Registration failed: ${err.response.data.message}`);
                if (err.response.data.errors) {
                    const detailedErrors = err.response.data.errors.join(', ');
                    setError(prevError => `${prevError} Details: ${detailedErrors}`);
                }
            } else if (err.request) {
                setError('Registration failed: No response from server. Ensure the backend is running.');
            } else {
                setError(`Registration failed: ${err.message}`);
            }
        }
    };

    return (
        <div className="form-container">
            <h2>Register</h2>
            <form onSubmit={handleSubmit}>
                {error && <p style={{ color: 'red' }}>{error}</p>}
                {successMessage && <p style={{ color: 'green' }}>{successMessage}</p>}
                <div>
                    <label htmlFor="username">Username:</label>
                    <input
                        type="text"
                        id="username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                    />
                </div>
                <div>
                    <label htmlFor="email">Email:</label>
                    <input
                        type="email"
                        id="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                </div>
                <div>
                    <label htmlFor="password">Password:</label>
                    <input
                        type="password"
                        id="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                </div>
                <div>
                    <label htmlFor="confirmPassword">Confirm Password:</label>
                    <input
                        type="password"
                        id="confirmPassword"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                    />
                </div>
                <button type="submit">Register</button>
            </form>
            {successMessage && (
                <p>
                    Go to <Link to="/login">Login</Link>
                </p>
            )}
        </div>
    );
}

export default RegisterPage; 